<template>
    <div class="captail_wrap registrationSteps position-relative fullLoader p-0">
        <loader v-if="pageLoader"></loader>
        <div class="middle_section m-0 mobdesign">
            <div class="top_searchbars">
                <div class="col-12">
                    <div class="cap_logo mob-text-center noBG">
                        <router-link to="/home"><img src="../../../../static/website/images/logo.svg"
                                alt="Captail wallet"></router-link>
                    </div>
                </div>
            </div>

            <div class="mid_scroll_content d-flex align-items-center justify-content-center mt-custom"
                v-if="showSection == '1'">
                <section class="stepsForm-include border-0 w-100">
                    <div class="row justify-content-center">
                        <div class="col-12 col-md-10 col-xl-7">
                            <div class="lt-aler-message" v-if="notification_msg != ''">
                                <alert-notification />
                            </div>
                            <h3 class="text-center">Register with Capital Wallet</h3>
                            <div class="row mt-5">
                                <div class="col-12">
                                    <p class="alert alert-danger" v-if="errors.first('account type')">
                                        {{errors.first('account type')}}</p>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="selectAccount">
                                        <label class="customRadioButton">
                                            <h4>Individual Account</h4>
                                            <p>Please provide the necessary information requested in the form. We
                                                collect this data to comply with the anti-money laundering laws and to
                                                verify your identity.</p>
                                            <input type="radio" name="account type" value="0" v-model="accountType"
                                                v-validate="'required'"
                                                :class="{ 'is-invalid': submitted && errors.has('account type') }">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="selectAccount">
                                        <label class="customRadioButton">
                                            <h4>Corporate Account</h4>
                                            <p>To register for a corporate account you are required to share information
                                                about your business, your intended use of the account, and the ownership
                                                of your business.</p>
                                            <input type="radio" name="account type" value="1" v-model="accountType" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('account type') }">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="submitButton addpadBottom-res text-center mt-3 mt-md-5">
                                        <button class="cap_btn blue px-4" @click="accountTypeFunc1()">Continue</button>
                                        <router-link class="backLogin" :to="'/'">Already have an account? Log in
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <!-- Step 2 start---------------------------- -->
            <div class="mid_scroll_content d-flex align-items-center justify-content-center mt-custom"
                v-if="showSection == '2'">
                <section class="stepsForm-include border-0 w-100">
                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-5 stepBorder box-shadow text-center">
                            <div class="lt-aler-message" v-if="notification_msg != ''">
                                <alert-notification />
                            </div>
                            <!-- <h3 class="text-center mb-4">Enter your Country of Residence</h3> -->
                            <form class="mt-4">
                                <div class="form-group text-left">
                                    <label class="labeltext">Select Your Country</label>
                                    <v-select :options="Object.values(countrylist)" :reduce="country => country.iso2"
                                        v-model="residence_country" label="name" placeholder="" name="Country_Name"
                                        v-validate="'required'" :autocomplete="'off'" v-on:change="cuntryChange()"></v-select>
                                    <span v-show="submitted && errors.has('Country_Name')" class="text-danger">The
                                        Residence Country is required</span>
                                </div>
                                <div class="submitButton text-center mt-3 mt-md-5">
                                    <button class="cap_btn blue px-4" @click.prevent="countryfun()">Continue</button>
                                    <router-link class="backLogin" :to="'/'">Already have an account? Log in
                                    </router-link>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
            <!-- Step 3 Start------------------------------- -->
            <div class="mid_scroll_content d-flex align-items-center justify-content-center mt-custom"
                v-if="showSection == '3'">
                <section class="stepsForm-include border-0 w-100">
                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-5 stepBorder box-shadow text-center">
                            <div class="lt-aler-message" v-if="notification_msg != ''">
                                <alert-notification />
                            </div>
                            <h3 class="text-center mb-4">Insert your email</h3>
                            <!-- <p>Please provide a unique email that is not associated with another {{$env_var.productName}} account</p> -->
                            <form class="mt-4" @submit.prevent="submit()">
                                <div class="form-group text-left">
                                    <!-- <label class="labeltext">Enter Your Corporate Email</label> -->
                                    <input type="text" class="form-control" v-model="email" name="email"
                                        v-validate="'required|email'" placeholder=" "
                                        :class="{ 'is-invalid': submitted && errors.has('email') }">
                                    <p class="error" v-for="list in errors.collect('email')" v-if="submitted && errors.has('email')">
                                        <span v-if="list == 'The email field must be a valid email'">Invalid email. Please insert a valid email address</span>
                                        <span v-else>{{list}}</span>
                                    </p>
                                </div>
                                <div class="submitButton text-center mt-3 mt-md-5">
                                    <input type="button" class="cap_btn blue px-4 large_btn" value="Sign Up"
                                        v-on:click.stop.prevent="submit" :class="(pageLoader)?'disabled':''" />
                                    <router-link class="backLogin" :to="'/'">Already have an account? Log in
                                    </router-link>
                                    <!-- <a href="https://capitalwallet.com/terms" target="_blank">Terms of Use</a> -->
                                    <p>By clicking on Sign Up, you aknowledge that you have read and accept the <a href="https://www.capitalwallet.com/global/terms-of-use" style="text-decoration: underline;" target="_blank">Terms of Use</a> and  our <a href="https://www.capitalwallet.com/global/privacy-policy" style="text-decoration: underline;" target="_blank">Privacy Policy</a></p>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
        </div>
        <div id="exampleModalaus" class="modal fade show" style="display: block" v-if="popup == 1">
            <div class="modal-dialog w-100 modal-dialog-centered" role="document">
                <div class="modal-content">
                    <button class="close text-right pr-2" @click="ausPopFun()">
                        <span aria-hidden="true">×</span>
                    </button>
                    <div class="modal-body expired text-center">
                        <!-- <img src="../../../../static/website/images/laptop-1.svg" alt="API" title="API"/> -->
                        <!-- <h5 class="mb-3">Aus</h5> -->
                        <p>The country you have selected is  outside EU , please use the link below to complete the registration process for Non-EU residents</p>
                        <div class="mt-4 mb-2 d-flex align-items-center justify-content-center">
                        <a href="https://client.capitalwallet.com/" target="_blank" class="cap_btn large_btn border-btn">Click Here</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div id="exampleModalest" class="modal fade show" style="display: block" v-if="popup == 2">
            <div class="modal-dialog w-100 modal-dialog-centered" role="document">
                <div class="modal-content">
                    <button class="close text-right pr-2" @click="ausPopFun()"><span aria-hidden="true">×</span></button>
                    <div class="modal-body expired text-center">
                        <img src="../../../../static/website/images/laptop-1.svg" alt="API" title="API"/>
                        <h5 class="mb-3">Est</h5>
                        <p>Please refresh the page. Dont't worry, we kept all of your filters and breakdowns in place</p>
                        <div class="mt-4 mb-2 d-flex align-items-center justify-content-center">
                        <a href="javascript:void(0)" class="cap_btn large_btn border-btn">Click Here</a>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
    import { Const } from '@/plugins/registerSteps/provider/lib/const.cls.ts'
    import { registerStepsMixins } from '@/plugins/registerSteps'
    import { mapActions } from 'vuex'
    import * as types from '@/types'
    export default {
        name: 'step-one',
        mixins: [registerStepsMixins],
        data() {
            return {
                showSection: '3',
                accountType: '1',
                residence_country: '',
                submitted: false,
                pageLoader: false,
                notification_msg: '',
                notification_type: '',
                aus: [
                    "AU", "JP", "MY", "EC", "NZ", "SG", "TW", "AM", "TH", "AR", "BR", "CL", "CO", "SV", "PE", "UY", "BB", "BZ", "CR", "DM", "DO", "GD", "GT", "HN", "JM", "PY", "KN", "LC", "VC", "TC", "VI", "PR"
                ],
                // est: [
                //     "AT", "GG", "BG", "CZ", "DK", "EE", "FI", "GL", "HU", "IE", "IT", "LV", "LT", "PL", "PT", "ES", "AO", "DJ", "CI", "MG", "MR", "RW", "ST", "ZA", "CH", "GM", "TG", "SA", "KZ", "NG", "TJ", "TM", "AE", "AZ"
                // ],
                popup:0,
                email: '',
            }
        },
        watch: {
            residence_country: function (val) {
                if (val != 'US' && this.nationality != 'US') {
                    this.us_person = '0'
                }
            },
            residence_country(val){
                this.cuntryChange()
            }
        },
        computed: {
            countrylist() {
                return this.$store.getters[types.GET_COUNTRY];
            }
        },
        methods: {
            ...mapActions({
                _runCountryList: types.RUN_COUNTRY
            }),
            getcountries() {
                let input_json = {
                    'globalParams': {},
                    'localParams': {
                        "parameter": this
                    }
                }
                this._runCountryList(input_json)
            },
            accountTypeFunc1() {
                const _that = this
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        if(this.accountType == 1){
                            _that.showSection = '3'
                            _that.submitted = false
                        }
                        else {
                            _that.showSection = '2'
                            _that.submitted = false
                        }
                    }
                })
            },
            countryfun() {
                const _that = this
                this.submitted = true;
                this.$validator.validate().then(valid => {
                     if (valid) {
                        _that.showSection = '3'
                        _that.submitted = false
                    }
                })
            },
            ausPopFun(){
                this.popup = 0;
                this.residence_country= ''
            },
            // restPopFun(){
            //     this.popup = 0;
            //     this.residence_country= ''
            // },
            cuntryChange(){
                if(this.residence_country){
                    if(this.aus.includes(this.residence_country)){
                        this.popup = 1
                    } else {
                        this.popup = 0
                    }
                }
            },
            submit() {
                if (this.pageLoader) { return; }
                const _that = this
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json = {
                            'globalParams': {
                                'email': _that.email,
                                'account_type': _that.accountType,
                                'residence_country': _that.residence_country
                            },
                            'localParams': { "parameter": _that }
                        }
                        _that._runStep1(input_json)
                    }
                })
            }
        },
        mounted(){
            this.getcountries()
        },
        created() {
            const _that = this
            let transfer_token = null
            if (localStorage.getItem('transfer_token')) {
                transfer_token = localStorage.getItem('transfer_token')
            }
            if (localStorage.getItem("step2") === null) {
                localStorage.clear();
            } else {
                const localValue = JSON.parse(localStorage.getItem("step2"));
                this.showSection = '2'
                this.accountType = localValue.account_type
                this.email = localValue.email
                this.residence_country = localValue.residence_country
                localStorage.clear();
                // localStorage.clear();
            }
            this.$store.commit(Const.SET_STEP2, {})
            this.$store.commit(Const.SET_STEP3, {})
            if (transfer_token) {
                localStorage.setItem('transfer_token', transfer_token)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/registerSteps/email_step.vue